var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarningIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7812 14.7812C19.3438 15.7812 18.625 17 17.4688 17H2.5C1.34375 17 0.625 15.75 1.1875 14.7812L8.6875 1.75C9.25 0.75 10.7188 0.78125 11.2812 1.75L18.7812 14.7812ZM10 12.0625C9.1875 12.0625 8.5625 12.7188 8.5625 13.5C8.5625 14.3125 9.1875 14.9375 10 14.9375C10.7812 14.9375 11.4375 14.3125 11.4375 13.5C11.4375 12.7188 10.7812 12.0625 10 12.0625ZM8.625 6.90625L8.84375 11.1562C8.875 11.375 9.03125 11.5 9.21875 11.5H10.75C10.9375 11.5 11.0938 11.375 11.125 11.1562L11.3438 6.90625C11.375 6.6875 11.1875 6.5 10.9688 6.5H9C8.78125 6.5 8.59375 6.6875 8.625 6.90625Z",
    fill: "#EB6D00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.f7070676579e8351c72133d9acbf73e2.svg";
export { ForwardRef as ReactComponent };